import { get } from '../../../utils/state';

const getScrollCoordinates = state => get(state, 'utils.storeScrollCoordinates', {});
const selectIsRebrand = state => get(state, 'utils.isRebrand', false);
const getOrgAssociationById = id => state => get(state, `utils.orgAssociations[${id}]`, false);

export {
  getScrollCoordinates,
  selectIsRebrand,
  getOrgAssociationById,
};

export default {
  getScrollCoordinates,
  selectIsRebrand,
  getOrgAssociationById,
};
